<vdr-card
  [title]="'common.application-apk' | translate"
  style="margin-top: 1rem"
>
  <div class="selected-file-card" *ngIf="selectedFile; else unselected">
    <div style="display: flex; justify-content: space-between">
      <div style="display: flex; align-items: center">
        <div style="margin-right: 0.7rem">
          <clr-icon shape="file" size="24"></clr-icon>
        </div>
        <div>
          {{ selectedFile.information.name }}
        </div>
        <a
          target="_blank"
          [href]="selectedFile.information.link"
          style="margin-left: 0.5rem"
          *ngIf="selectedFile.information.link"
        >
          <clr-icon shape="link" size="24"></clr-icon>
        </a>
      </div>
      <div style="display: flex; align-items: center">
        <div style="cursor: pointer" (click)="remove()">
          <clr-icon shape="times" size="36"></clr-icon>
        </div>
      </div>
    </div>
  </div>

  <ng-template #unselected>
    <div class="unselect-file-card">
      <div style="display: flex; align-items: center">
        <div style="margin-right: 1rem">
          {{ "common.no-selected-file" | translate }}
        </div>
        <custom-asset-file-input
          *ngIf="!selectedFile"
          class="ml3"
          (selectFiles)="createAssets($event)"
          [uploading]="uploading"
          dropZoneTarget=".modal-content"
          [acceptTypes]="['.apk']"
          [multiple]="false"
        ></custom-asset-file-input>
      </div>
    </div>
  </ng-template>

  <button
    [disabled]="!changes || !selectedFile?.needCreatedAssetFile"
    style="display: block; margin-top: 1rem"
    class="btn btn-primary"
    (click)="save()"
  >
    <ng-container *ngIf="saving; else selectable">
      <clr-spinner clrInline></clr-spinner>
      {{ "common.save" | translate }}
    </ng-container>
    <ng-template #selectable>
      {{ "common.save" | translate }}
    </ng-template>
  </button>
</vdr-card>
